<mat-menu class="rowActionMenu"
          #rowActionMenu="matMenu">
  <ng-template matMenuContent
               let-location="location">
    <ng-container *ngrxLet="getMenuViewModel$(location); let value;">
      <button mat-menu-item
              class="dropdown-menu-option"
              (click)="locationListService.activateLocationDetail(location.id, locationDetail.UPDATES)"
              appGtagEvent
              trackOn="click"
              action="show BLS updates"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Show BLS updates'}">
        <mat-icon svgIcon="update"></mat-icon>
        Show BLS updates
      </button>
      <button mat-menu-item
              class="dropdown-menu-option"
              (click)="locationListService.refreshGbpConnections([location])"
              [disabled]="!value.canRefreshGbp"
              appGtagEvent
              trackOn="click"
              action="get updates from GMB"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Get updates from GMB for a single location'}">
        <mat-icon svgIcon="arrow_downward"></mat-icon>
        Get updates from GBP
      </button>
      <button mat-menu-item
              class="dropdown-menu-option"
              (click)="locationListService.activateLocationDetail(location.id, locationDetail.COMPARE)"
              appGtagEvent
              trackOn="click"
              action="show differences"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Show differences between BLS and GMB'}">
        <mat-icon svgIcon="compare_arrows"></mat-icon>
        Compare to GBP
      </button>
      <button mat-menu-item
              class="dropdown-menu-option"
              (click)="locationListService.activateLocationDetail(location.id, locationDetail.EDIT)"
              appGtagEvent
              trackOn="click"
              action="edit BLS data"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Edit data in BLS'}">
        <mat-icon svgIcon="edit"></mat-icon>
        Edit data in BLS
      </button>
      <button mat-menu-item
              class="dropdown-menu-option"
              (click)="locationListService.openBatchModifyLocationGroupsDialog(location)"
              appGtagEvent
              trackOn="click"
              action="open batch-modify location groups popup"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Open batch-modify location groups popup'}"
              [disabled]="!value.canTransfer"
      >
        <mat-icon svgIcon="batch_modify_location_groups"></mat-icon>
        Transfer
      </button>
      <button mat-menu-item
              class="dropdown-menu-option"
              [disabled]="!value.canUpdateInGbp"
              (click)="locationListService.updateInGbpAndSendToGoogleAnalytics([location])">
        <mat-icon svgIcon="update_in_gmb"></mat-icon>
        Update in GBP
      </button>
      <button mat-menu-item
              class="dropdown-menu-option"
              (click)="locationListService.activateLocationDetail(location.id, locationDetail.COORDINATE_VALIDATION)">
        <mat-icon svgIcon="where_to_vote_outlined"></mat-icon>
        Validate
      </button>
      <button mat-menu-item
              (menuOpened)="gridApiService.refocusCell()"
              [matMenuTriggerFor]="moreActionsMenu"
              [matMenuTriggerData]="{location: location}"
              class="dropdown-menu-option">
        <mat-icon svgIcon="more_vert"></mat-icon>
        More actions
      </button>

      <mat-divider class="dropdownMenuOptionDivider"></mat-divider>

      <button mat-menu-item
              class="dropdown-menu-option"
              [disabled]="!value.canCreateGbpConnection"
              (click)="locationListService.editGBPConnection(location, 'create')"
              appGtagEvent
              trackOn="click"
              action="create GMB location"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Create a new GMB location for a BLS location'}">
        <mat-icon svgIcon="add_circle_outline"></mat-icon>
        Create new GBP location
      </button>
      <button mat-menu-item
              class="dropdown-menu-option"
              [disabled]="!value.canRemoveGbpConnection"
              (click)="locationListService.editGBPConnection(location, 'remove')"
              appGtagEvent
              trackOn="click"
              action="unlink from GMB location"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Unlink BLS location from linked GMB connection'}">
        <mat-icon svgIcon="link_off"></mat-icon>
        Unlink from GBP location
      </button>
    </ng-container>
  </ng-template>
</mat-menu>

<mat-menu class="rowActionMenu"
          #moreActionsMenu="matMenu">
  <ng-template matMenuContent
               let-location="location">
    <ng-container *ngrxLet="getMenuViewModel$(location); let value">
      <button mat-menu-item
              class="dropdown-menu-option"
              [disabled]="!value.canBlacklist"
              (click)="locationListService.openBlacklistFieldsDialog([location])"
              appGtagEvent
              trackOn="click"
              action="blacklist"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Blacklist fields of a single location'}">
        <mat-icon svgIcon="blacklist_locations"></mat-icon>
        Blacklist
      </button>
      <button mat-menu-item
              class="dropdown-menu-option"
              [disabled]="!value.canArchive"
              (click)="locationListService.archiveLocations([location])"
              appGtagEvent
              trackOn="click"
              action="archive"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Archive a single location'}">
        <mat-icon svgIcon="archive_locations"></mat-icon>
        Archive
      </button>
      <button mat-menu-item
              class="dropdown-menu-option"
              [disabled]="!value.canSyncReviews"
              (click)="locationListService.syncReviews(location)">
        <mat-icon svgIcon="sync"></mat-icon>
        Sync reviews
      </button>
      <button mat-menu-item
              class="dropdown-menu-option"
              [disabled]="!value.canIgnoreLastUpdateError"
              (click)="locationListService.ignoreLastUpdateError(location)"
              appGtagEvent
              trackOn="click"
              action="ignore last update error"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Ignore the last update error'}">
        <mat-icon svgIcon="highlight_off"></mat-icon>
        Ignore last update error
      </button>
      <button mat-menu-item
              class="dropdown-menu-option"
              (click)="toggleShowTranslation(location.id)"
              appGtagEvent
              trackOn="click"
              action="Toggle show translation"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Toggle show translation'}"
      >
        <mat-icon svgIcon="translate"></mat-icon>
        {{ value.showTranslation ? "Original language" : "Translate" }}
      </button>
    </ng-container>
  </ng-template>
</mat-menu>
